export default __webpack_public_path__ + "static/media/livetheater.8a372724.png";